import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./components/App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import "./i18n";
import "./index.scss";
import "@suezenv/signal-widget/dist/index.css";

ReactDOM.render(
    <BrowserRouter>
        <Suspense fallback={<></>}>
            <Provider store={store}>
                <App />
            </Provider>
        </Suspense>
    </BrowserRouter>,
    document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
